import { useTranslation } from 'react-i18next'
import { Card, FlowLayout, Icon } from '@/ds'
import { useAppNavigate } from '@/lib/query-params'
import { useCheckinFlow } from '../CheckinFlow'
import type { EntryChoice } from '../flow'
import { progressFor, stepPath } from '../flow'

const LEGACY = 'v2.legacy.stepper.collectDataForm'

/**
 * Elección del método al pulsar "Registrar" (inventario D33, decisión del usuario): como la app actual
 * (CollectDataForm), la persona elige entre rellenar los datos a mano o capturarlos con una foto del
 * documento. Sin `.dc.html` propio: textos de la app actual y tarjetas del sistema. "A mano" no se ofrece
 * con `forceScan` (en ese caso Ocupantes salta esta pantalla).
 */
export function Metodo() {
  const { t } = useTranslation()
  const { go } = useAppNavigate()
  const { stay, draft, update } = useCheckinFlow()
  const forceScan = stay.registration.rules.forceScan

  const choose = (entry: EntryChoice) => {
    update({ entry, method: entry === 'manual' ? 'manual' : null, doubtful: [] })
    // A mano: Tus datos y el formulario. Captura: país y documento antes de iniciar la cámara.
    go(stepPath(entry === 'manual' ? '2' : '2c'))
  }

  const options: { entry: EntryChoice; icon: 'pen' | 'camera'; label: string }[] = [
    ...(forceScan ? [] : [{ entry: 'manual' as const, icon: 'pen' as const, label: t(`${LEGACY}.option1`) }]),
    { entry: 'capture', icon: 'camera', label: t(`${LEGACY}.option2`) },
  ]

  return (
    <FlowLayout
      progress={{ step: 1, total: Math.max(progressFor('1c', stay, draft.persona, null, 'capture').total, forceScan ? 0 : progressFor('1c', stay, draft.persona, 'manual', 'manual').total), backLabel: t('v2.checkin.atras.ocupantes'), onBack: () => go(stepPath('1')) }}
      title={t(`${LEGACY}.header`)}
    >
      <ul className="checkin__choices">
        {options.map((o) => (
          <li key={o.entry}>
            <Card onClick={() => choose(o.entry)} hoverable className={draft.entry === o.entry ? 'checkin__choice checkin__choice--current' : 'checkin__choice'}>
              <span className="checkin__choice-body">
                <Icon name={o.icon} size={28} className="checkin__choice-icon" />
                <span className="checkin__choice-label">{o.label}</span>
                <Icon name="chevron-right" size={22} className="checkin__choice-chevron" />
              </span>
            </Card>
          </li>
        ))}
      </ul>
    </FlowLayout>
  )
}
